import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";
import { IUserCountryTask } from "../interfaces/iusercountrytask";

@Injectable()
export class UserCountryTaskService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Get List of users country tasks
     */
    getUserCountryTasks(): Observable<IUserCountryTask[]> {
        return super.get("/api/usercountrytasks").pipe(map((res: any) => res as IUserCountryTask[]));
    }
}





